<script setup name="UserListUserRoleChip">
defineProps({
  role: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <div class="flex flex-col justify-evenly">
    <p class="text-sm text-charcoal-6">User Role</p>
    <div class="min-w-min max-w-max rounded-md capitalize">
      <p>{{ role }}</p>
    </div>
  </div>
</template>
